import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@client.components/Tooltip";

export const CHART_CLASS = "top-meeting-participants";
export const XAXIS_PADDING = { left: 50, right: 70 };

const CustomXAxisTick = (props) => {
  const { x, y, payload, barQty } = props;
  const xAxisElement = document.querySelector(`.${CHART_CLASS}`);
  const tickWidth =
    barQty === 0
      ? 0
      : parseInt(
          (xAxisElement.clientWidth -
            XAXIS_PADDING.left -
            XAXIS_PADDING.right) /
            barQty
        );
  const tickX = x - tickWidth / 2;
  return (
    <foreignObject x={tickX} y={y} width={tickWidth} height={40}>
      <Tooltip
        content={<span className="recharts-text-tooltip">{payload.value}</span>}
      >
        <div className="recharts-text x-axis-text">{payload.value}</div>
      </Tooltip>
    </foreignObject>
  );
};

CustomXAxisTick.propTypes = {
  barQty: PropTypes.number.isRequired,
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.any,
};

export default CustomXAxisTick;
